import { useState } from "react";
import "./App.css";
import { BINARY_SYSTEM, MAYA_SYSTEM, ROMAN_SYSTEM } from "./defaults";
import Tutorial0Binary from "./tutorials/tutorial0Binary";
import Tutorial0Maya from "./tutorials/tutorial0Maya";
import Tutorial0Roman from "./tutorials/tutorial0Roman";
import Tutorial1Binary from "./tutorials/tutorial1Binary";
import Tutorial1Maya from "./tutorials/tutorial1Maya";
import Tutorial1Roman from "./tutorials/tutorial1Roman";
import Tutorial2Binary from "./tutorials/tutorial2Binary";
import Tutorial2Maya from "./tutorials/tutorial2Maya";
import Tutorial2Roman from "./tutorials/tutorial2Roman";
import Tutorial3Binary from "./tutorials/tutorial3Binary";
import Tutorial3Maya from "./tutorials/tutorial3Maya";
import Tutorial3Roman from "./tutorials/tutorial3Roman";
import Tutorial4Binary from "./tutorials/tutorial4Binary";
import Tutorial4Maya from "./tutorials/tutorial4Maya";
import Tutorial4Roman from "./tutorials/tutorial4Roman";
import Tutorial5Binary from "./tutorials/tutorial5Binary";
import Tutorial5Roman from "./tutorials/tutorial5Roman";
import Tutorial6Binary from "./tutorials/tutorial6Binary";
import Tutorial7Binary from "./tutorials/tutorial7Binary";

function Tutorial({ whichSystem, level, finishTutorial }) {
    
    const [page, setPage] = useState(0); // Which page of the tutorial to display. Think of the tutorial like a book containing text.

    const handleNext = () => {
        setPage(n => n + 1)
    };

    const handlePrevious = () => {
        setPage(n => n - 1)
    };

    switch (whichSystem) {
        case ROMAN_SYSTEM:
            switch(level) {
                case 0: return (<Tutorial0Roman finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 1: return (<Tutorial1Roman finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 2: return (<Tutorial2Roman finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 3: return (<Tutorial3Roman finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 4: return (<Tutorial4Roman finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 5: return (<Tutorial5Roman finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
            }
        case BINARY_SYSTEM:
            switch(level) {
                case 0: return (<Tutorial0Binary finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 1: return (<Tutorial1Binary finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 2: return (<Tutorial2Binary finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 3: return (<Tutorial3Binary finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 4: return (<Tutorial4Binary finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 5: return (<Tutorial5Binary finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 6: return (<Tutorial6Binary finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 7: return (<Tutorial7Binary finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
            }
        case MAYA_SYSTEM:
            switch(level) {
                case 0: return (<Tutorial0Maya finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 1: return (<Tutorial1Maya finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 2: return (<Tutorial2Maya finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 3: return (<Tutorial3Maya finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
                case 4: return (<Tutorial4Maya finishTutorial={finishTutorial} page={page} handleNext={handleNext} handlePrevious={handlePrevious}/>);
            }
    }
}

export default Tutorial;